import { Component, Input } from '@angular/core';
import { StepProps, stepStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-step',
  template: `<div [ngClass]="stepStyles">
    <ng-content></ng-content>
  </div>`,
})
export class StepComponent {
  @Input() css: StepProps['css'];

  _isDisabled = false;

  @Input() get isDisabled() {
    return this._isDisabled;
  }

  set isDisabled(val: boolean) {
    this._isDisabled = val;
  }

  get stepStyles(): string[] {
    return [
      stepStyles({
        isDisabled: this.isDisabled,
        css: this.css,
      }).className,
    ];
  }
}
